const EmailTemplateGroup = Object.freeze({
	Customer: 'Customer',
	Agent: 'Agent',
});

const EmailTemplates = Object.freeze({
	// Customer notifications (sent to customer contacts)
	NewJobEmail: Object.freeze({
		key: 'NewJobEmail',
		title: 'New job',
		description: 'Sent to the customer when a new job is created.',
		descriptionLong: `Activated when the From field is filled.
Includes subject and body from the template.`,
		group: EmailTemplateGroup.Customer,
	}),
	OrderConfirmationEmail: Object.freeze({
		key: 'OrderConfirmationEmail',
		title: 'New order',
		description: 'Sent to the customer when an order is created.',
		descriptionLong: `Activated when the From field is filled.
Includes subject and body from the template.`,
		group: EmailTemplateGroup.Customer,
	}),
	SupportJobConfirmationEmail: Object.freeze({
		key: 'SupportJobConfirmationEmail',
		title: 'New support job',
		description: 'Sent to the customer for support jobs.',
		descriptionLong: `Activated when the From field is filled.
Uses the support confirmation subject and body.`,
		group: EmailTemplateGroup.Customer,
	}),
	CompletedJobEmail: Object.freeze({
		key: 'CompletedJobEmail',
		title: 'Completed job',
		description: 'Sent to the customer when a job is completed.',
		descriptionLong: `Sent to the job’s customer contact.
Uses the completed job subject and body.`,
		group: EmailTemplateGroup.Customer,
	}),
	AppointmentConfirmationEmail: Object.freeze({
		key: 'AppointmentConfirmationEmail',
		title: 'Appointment confirmation',
		description: 'Sent on appointment create/change.',
		descriptionLong: `Recipient is the customer contact.
Uses the appointment confirmation subject and body.`,
		group: EmailTemplateGroup.Customer,
	}),
	AppointmentInformationEmail: Object.freeze({
		key: 'AppointmentInformationEmail',
		title: 'Appointment information',
		description: 'Invitation/information to technicians about the appointment.',
		descriptionLong: `Activated when the From field is filled.
Used for internal participants.
Partner invitations use the Partner invitation template.`,
		group: EmailTemplateGroup.Agent,
	}),
	SendServiceReportEmail: Object.freeze({
		key: 'SendServiceReportEmail',
		title: 'Service report',
		description: `Template used when a technician sends a service report to the customer contact, 
from the technician app.`,
		descriptionLong: `Often includes a PDF attachment.
Activated when the From field is filled.`,
		group: EmailTemplateGroup.Customer,
	}),

	// Agent emails (internal or non-customer recipients)
	VendorOrderEmail: Object.freeze({
		key: 'VendorOrderEmail',
		title: 'Vendor order',
		description: 'Internal email to a vendor for purchasing.',
		descriptionLong: `Activated when the To field is filled.
Uses the vendor order subject and body.`,
		group: EmailTemplateGroup.Agent,
	}),
	WarehouseManagerEmail: Object.freeze({
		key: 'WarehouseManagerEmail',
		title: 'Warehouse movement',
		description: 'Internal email to the warehouse manager about stock movements.',
		descriptionLong: `Activated when the To field is filled.
Uses the warehouse manager subject and body.`,
		group: EmailTemplateGroup.Agent,
	}),
	PartnerAppointmentInformationEmail: Object.freeze({
		key: 'PartnerAppointmentInformationEmail',
		title: 'Partner invitation',
		description: 'Invitation for partners or subcontractors with a portal link.',
		descriptionLong: `Requires Partner Portal license.
Sent to partner/subcontractor participants on appointment create/update.`,
		group: EmailTemplateGroup.Agent,
	}),
	NewLeadEmail: Object.freeze({
		key: 'NewLeadEmail',
		title: 'New lead',
		description: 'Internal sales notification when a new lead is created.',
		descriptionLong: `Sends lead details to your sales email address.`,
		group: EmailTemplateGroup.Agent,
	}),
	ServiceSystem_NotificationEmail: Object.freeze({
		key: 'ServiceSystem_NotificationEmail',
		title: 'System notification',
		description: 'Internal system notification email.',
		descriptionLong: `Activated when the To field is filled.`,
		group: EmailTemplateGroup.Agent,
	}),
});

export { EmailTemplateGroup };
export default EmailTemplates;
